/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MedicationSummaryDeliveryTrackOrderStatus } from '../model/medicationSummaryDeliveryTrackOrderStatus';
import { MedicationSummaryExceptionOrderStatusPollerModel } from '../model/medicationSummaryExceptionOrderStatusPollerModel';
import { MedicationSummaryOrderStatus } from '../model/medicationSummaryOrderStatus';
import { SortFilterDto } from '../model/sortFilterDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class OrderStatusService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Return list of orders with deliverytrack status &#x3D; delivered
     * The list will show a one to one mapping of each resident to a specific medication delivery        Sample Call      http://URL/api/OrderStatus/GetDeliveredOrders?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgList&#x3D;10wilm
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational Unit to return data for, should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderStatusGetDeliveredOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderStatus>;
    public orderStatusGetDeliveredOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderStatus>>;
    public orderStatusGetDeliveredOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderStatus>>;
    public orderStatusGetDeliveredOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling orderStatusGetDeliveredOrders.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling orderStatusGetDeliveredOrders.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderStatusGetDeliveredOrders.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderStatusGetDeliveredOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderStatus>(`${this.basePath}/api/OrderStatus/GetDeliveredOrders`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return list of delivery manifests within the desired time range.
     * Sample Call  http://URL/api/OrderStatus/GetDeliveryManifests?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgList&#x3D;10wilm
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational Unit to return data for, should not contain a region
     * @param sortFilterDto Sorts and filters the user has selected in the UI
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderStatusGetDeliveryManifests(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryDeliveryTrackOrderStatus>;
    public orderStatusGetDeliveryManifests(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryDeliveryTrackOrderStatus>>;
    public orderStatusGetDeliveryManifests(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryDeliveryTrackOrderStatus>>;
    public orderStatusGetDeliveryManifests(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling orderStatusGetDeliveryManifests.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling orderStatusGetDeliveryManifests.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderStatusGetDeliveryManifests.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderStatusGetDeliveryManifests.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryDeliveryTrackOrderStatus>(`${this.basePath}/api/OrderStatus/GetDeliveryManifests`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return Orders that have Exceptions
     * The list will show a one to one mapping of each resident to a specific medication        Sample Call      http://URL/api/OrderStatus/GetOrderExceptions?startDateRange&#x3D;2016-1-1T12:30:00&amp;amp;endDateRange&#x3D;2016-1-1T12:30:00%amp;orderTracking&#x3D;true&amp;amp;orgList&#x3D;10wilm
     * @param startDateRange Date to start searching for data from
     * @param endDateRange Date to start searching for data from
     * @param orderTracking True if data requested is order tracking and false for order status data
     * @param orgUnit Organizational Unit to return data for, should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderStatusGetOrderExceptions(startDateRange: Date, endDateRange: Date, orderTracking: boolean, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryExceptionOrderStatusPollerModel>;
    public orderStatusGetOrderExceptions(startDateRange: Date, endDateRange: Date, orderTracking: boolean, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryExceptionOrderStatusPollerModel>>;
    public orderStatusGetOrderExceptions(startDateRange: Date, endDateRange: Date, orderTracking: boolean, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryExceptionOrderStatusPollerModel>>;
    public orderStatusGetOrderExceptions(startDateRange: Date, endDateRange: Date, orderTracking: boolean, orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDateRange === null || startDateRange === undefined) {
            throw new Error('Required parameter startDateRange was null or undefined when calling orderStatusGetOrderExceptions.');
        }

        if (endDateRange === null || endDateRange === undefined) {
            throw new Error('Required parameter endDateRange was null or undefined when calling orderStatusGetOrderExceptions.');
        }

        if (orderTracking === null || orderTracking === undefined) {
            throw new Error('Required parameter orderTracking was null or undefined when calling orderStatusGetOrderExceptions.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderStatusGetOrderExceptions.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderStatusGetOrderExceptions.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDateRange !== undefined && startDateRange !== null) {
            queryParameters = queryParameters.set('startDateRange', <any>startDateRange.toISOString());
        }
        if (endDateRange !== undefined && endDateRange !== null) {
            queryParameters = queryParameters.set('endDateRange', <any>endDateRange.toISOString());
        }
        if (orderTracking !== undefined && orderTracking !== null) {
            queryParameters = queryParameters.set('orderTracking', <any>orderTracking);
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryExceptionOrderStatusPollerModel>(`${this.basePath}/api/OrderStatus/GetOrderExceptions`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return Orders in process
     * The list will show all orders currently in process         Sample Call      http://URL/api/OrderStatus/GetOrdersInProcess?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgList&#x3D;10wilm
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational Unit to return data for, should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderStatusGetOrdersInProcess(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderStatus>;
    public orderStatusGetOrdersInProcess(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderStatus>>;
    public orderStatusGetOrdersInProcess(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderStatus>>;
    public orderStatusGetOrdersInProcess(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling orderStatusGetOrdersInProcess.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling orderStatusGetOrdersInProcess.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderStatusGetOrdersInProcess.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderStatusGetOrdersInProcess.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderStatus>(`${this.basePath}/api/OrderStatus/GetOrdersInProcess`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return list of orders with deliverytrack status &#x3D; out for delivery
     * The list will show a one to one mapping of each resident to a specific medication delivery        Sample Call      http://URL/api/OrderStatus/GetOutForDeliveryOrders?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgList&#x3D;10wilm
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational Unit to return data for, should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderStatusGetOutForDeliveryOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderStatus>;
    public orderStatusGetOutForDeliveryOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderStatus>>;
    public orderStatusGetOutForDeliveryOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderStatus>>;
    public orderStatusGetOutForDeliveryOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling orderStatusGetOutForDeliveryOrders.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling orderStatusGetOutForDeliveryOrders.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderStatusGetOutForDeliveryOrders.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderStatusGetOutForDeliveryOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderStatus>(`${this.basePath}/api/OrderStatus/GetOutForDeliveryOrders`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return pending approval orders
     * The list will show pending approval orders        Sample Call      http://URL/api/OrderStatus/GetPendingApprovalOrders?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgList&#x3D;10wilm
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational Unit to return data for, should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderStatusGetPendingApprovalOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderStatus>;
    public orderStatusGetPendingApprovalOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderStatus>>;
    public orderStatusGetPendingApprovalOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderStatus>>;
    public orderStatusGetPendingApprovalOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling orderStatusGetPendingApprovalOrders.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling orderStatusGetPendingApprovalOrders.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderStatusGetPendingApprovalOrders.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderStatusGetPendingApprovalOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderStatus>(`${this.basePath}/api/OrderStatus/GetPendingApprovalOrders`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return Pharmacist approved orders
     * The list will show all Pharmacist approved orders withing the selected date range and org        Sample Call      http://URL/api/OrderStatus/GetPharmacistApprovedOrders?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgList&#x3D;10wilm
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational Unit to return data for, should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderStatusGetPharmacistApprovedOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderStatus>;
    public orderStatusGetPharmacistApprovedOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderStatus>>;
    public orderStatusGetPharmacistApprovedOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderStatus>>;
    public orderStatusGetPharmacistApprovedOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling orderStatusGetPharmacistApprovedOrders.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling orderStatusGetPharmacistApprovedOrders.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderStatusGetPharmacistApprovedOrders.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderStatusGetPharmacistApprovedOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderStatus>(`${this.basePath}/api/OrderStatus/GetPharmacistApproved`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return list of orders with deliverytrack status &#x3D; ready for delivery statuses
     * The list will show a one to one mapping of each resident to a specific medication delivery        Sample Call      http://URL/api/OrderStatus/GetReadyForDeliveryOrders?startDate&#x3D;2016-1-1T12:30:00&amp;amp;endDate&#x3D;2017-2-1T12:30:00&amp;amp;orgList&#x3D;10wilm
     * @param startDate Date to start searching for data from
     * @param endDate Stop Date
     * @param orgUnit Organizational Unit to return data for, should not contain a region
     * @param sortFilterDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orderStatusGetReadyForDeliveryOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOrderStatus>;
    public orderStatusGetReadyForDeliveryOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOrderStatus>>;
    public orderStatusGetReadyForDeliveryOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOrderStatus>>;
    public orderStatusGetReadyForDeliveryOrders(startDate: Date, endDate: Date, orgUnit: string, sortFilterDto: SortFilterDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (startDate === null || startDate === undefined) {
            throw new Error('Required parameter startDate was null or undefined when calling orderStatusGetReadyForDeliveryOrders.');
        }

        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling orderStatusGetReadyForDeliveryOrders.');
        }

        if (orgUnit === null || orgUnit === undefined) {
            throw new Error('Required parameter orgUnit was null or undefined when calling orderStatusGetReadyForDeliveryOrders.');
        }

        if (sortFilterDto === null || sortFilterDto === undefined) {
            throw new Error('Required parameter sortFilterDto was null or undefined when calling orderStatusGetReadyForDeliveryOrders.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }
        if (orgUnit !== undefined && orgUnit !== null) {
            queryParameters = queryParameters.set('orgUnit', <any>orgUnit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOrderStatus>(`${this.basePath}/api/OrderStatus/GetReadyForDeliveryOrders`,
            sortFilterDto,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
